import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-14880258"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "/img/kalogo.svg"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "2", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "2", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "2", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Die zwei Aspekte zeigt spielerisch diese App, die auf dem persönlichen CO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2"),
  /*#__PURE__*/_createTextVNode(" Rechner des "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://uba.co2-rechner.de/",
    target: "_blank"
  }, "Umweltbundesamtes (UBA)"),
  /*#__PURE__*/_createTextVNode(" basiert und für diese Aktion vereinfacht wurde. ")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ion-padding",
  slot: "content"
}, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Laut Energiebilanz Karlsruhe 2019 liegt der CO"),
    /*#__PURE__*/_createElementVNode("sub", null, "2"),
    /*#__PURE__*/_createTextVNode(" Ausstoß bei 7,8t jährlich pro Kopf. Die Effekte durch privaten Konsum sind dabei nicht enthalten. Addiert man hier den Grundwert (3,5t) gemäß unserer Vereinfachung des UBA-Modells, dann erhält man 11,3t CO"),
    /*#__PURE__*/_createElementVNode("sub", null, "2"),
    /*#__PURE__*/_createTextVNode(". Dies entspricht ungefähr der Grundwert-Summe der CO"),
    /*#__PURE__*/_createElementVNode("sub", null, "2"),
    /*#__PURE__*/_createTextVNode("APP (11t CO"),
    /*#__PURE__*/_createElementVNode("sub", null, "2"),
    /*#__PURE__*/_createTextVNode("). ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " Diese Grundwert-Summe bildet sich aus 4 \"Sektoren\", die wir durch unseren Lebensstil beinflussen können plus einer festen Zugabe für öffentliche Infrastruktur. "),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, " Wohnen (Heizung und Strom) "),
      /*#__PURE__*/_createElementVNode("li", null, " Mobilität "),
      /*#__PURE__*/_createElementVNode("li", null, " Ernährung "),
      /*#__PURE__*/_createElementVNode("li", null, " Allgemeiner Konsum ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Die verwendeten Daten und Berechnungsmodelle sind an den CO"),
    /*#__PURE__*/_createElementVNode("sub", null, "2"),
    /*#__PURE__*/_createTextVNode("-Rechner des Umweltbundesamts angeleht und wollen die Effekte zeigen, die wir durch sparsamen oder weniger sparsamen Lebensstil erreichen können. Eine exaktere Berechnung ist ohne weitere Informationen über die persönliche Situation im Einzelfall nicht möglich. Weitere Informationen zum UBA-Modell und den Einsparpotentialen finden sich "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.umweltbundesamt.de/publikationen/klimaneutral-leben",
      target: "_blank"
    }, "hier.")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Persönliche Maßnahmen für den Klimaschutz werden umso erfolgreicher, wenn wir auch andere Menschen davon überzeugen. Geben Sie Ihren Stadtteil an und die Anzahl der Personen, die sie dort als Mitstreiter:Innen gewinnen können und nehmen Sie so an der Klima-Challenge teil. Die aktuellen Ergebnisse sind auf unserem "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://co2dash.ok-lab-karlsruhe.de",
    target: "_blank"
  }, [
    /*#__PURE__*/_createTextVNode("CO"),
    /*#__PURE__*/_createElementVNode("sub", null, "2"),
    /*#__PURE__*/_createTextVNode("-Dashboard")
  ]),
  /*#__PURE__*/_createTextVNode(" sichtbar. ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Im Kanal \"Grüne Stadt\" der "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.karlsruhe.de/b4/stadtverwaltung/karlsruhe-app.de",
    target: "_blank"
  }, " Karlsruhe-App"),
  /*#__PURE__*/_createTextVNode(" wird das Umweltamt das Projekt weiter verfolgen. ")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Die Wohnungsgröße sowie die Energieträger für Heizung und Strom haben großen Einfluß auf die CO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2"),
  /*#__PURE__*/_createTextVNode(" Emissionen. Hier können Sie weniger (25m²) oder mehr (75m²) Wohnfläche wählen und als Heizenergieträger erneuerbare Energien (EE) sowie Ökostrom (Öko) angeben. ")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Die mobilitätsbedingten CO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2"),
  /*#__PURE__*/_createTextVNode(" Emissionen können durch den Verzicht auf ein Auto reduziert werden. Viele Flüge (z.B. 1 Transatlantikflug plus 4 europäische Flüge pro Jahr) hingegen produzieren sehr viel CO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Die Fleischproduktion sorgt für erhebliche CO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2"),
  /*#__PURE__*/_createTextVNode(" Emissionen. Hier können Sie über Ihre Essgewohnheiten Einfluß nehmen. ")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Unsere Konsumausgaben sorgen ebenfalls für CO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2"),
  /*#__PURE__*/_createTextVNode(" Emissionen. Geringere Ausgaben (z.B. 1000€ mtl.) oder hohe Ausgaben (z.B. 4500€ mtl.) haben einen deutlichen Effekt. Geldanlagen in klimaschonende anstelle von konverntionellen Produkten (\"grünes Konto\") tragen ebenfalls zur CO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2"),
  /*#__PURE__*/_createTextVNode(" Einsparung bei. ")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Können Sie weitere Menschen in Ihrem Stadtteil davon überzeugen, genauso viel CO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2"),
  /*#__PURE__*/_createTextVNode("-Einsparungen zu erreichen? Dann geben Sie hier eine Zahl ein. ")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, [
  /*#__PURE__*/_createTextVNode(" CO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2"),
  /*#__PURE__*/_createTextVNode(" runter – mein Beitrag für KA")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-text-center" }, " App-Design ", -1))
const _hoisted_16 = { class: "ion-text-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://ok-lab-karlsruhe.de",
  target: "_blank"
}, "OK Lab Karlsruhe", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "2", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_range = _resolveComponent("ion-range")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_card_footer = _resolveComponent("ion-card-footer")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "topHeader" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_item, { class: "headline-container" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_thumbnail, {
                class: "logo",
                slot: "start"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_label, { class: "headline" }, {
                default: _withCtx(() => [
                  _createTextVNode("CO"),
                  _hoisted_2,
                  _createTextVNode(" runter: App")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "onepnt5"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("CO"),
                      _hoisted_3,
                      _createTextVNode(" runter - Mein Beitrag für KA")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_subtitle, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Mitmach-App")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _createTextVNode(" Wie viel CO"),
                  _hoisted_4,
                  _createTextVNode(" kann ich durch einen veränderten Lebensstil einsparen und wie viel macht es in meinem Stadtteil aus, wenn ich noch andere in meinem Umfeld davon überzeuge? "),
                  _hoisted_5,
                  _createVNode(_component_ion_accordion_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_accordion, { value: "first" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            slot: "header",
                            color: "light"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Details")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_7,
                  _hoisted_8,
                  _createVNode(_component_ion_text, { color: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Ganz unten sehen Sie immer die aktuelle Berechnung")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, { class: "card-md" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Hier können Sie etwas tun: ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_subtitle, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Wohnen "),
                      _createVNode(_component_ion_icon, {
                        src: "/img/emoji/tent_emoji_u1f3d5.svg",
                        size: "large"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, { class: "sector" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_text, null, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_segment, {
                    onIonChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.segmentChanged($event,"s1"))),
                    value: "normal"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_segment_button, {
                        value: "besser",
                        layout: "icon-bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            src: "/img/emoji/house_emoji_u1f3e0.svg",
                            size: "small"
                          }),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Kleiner")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_segment_button, {
                        value: "normal",
                        layout: "icon-bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            src: "/img/emoji/house_emoji_u1f3e0.svg",
                            size: "normal"
                          }),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Normal")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_segment_button, {
                        value: "schlechter",
                        layout: "icon-bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            src: "/img/emoji/house_emoji_u1f3e0.svg",
                            size: "large"
                          }),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Größer")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_grid, { fixed: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { size: "6" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "check" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("EE")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_icon, {
                                    src: "/img/emoji/fire_emoji_u1f525.svg",
                                    size: "normal"
                                  }),
                                  _createVNode(_component_ion_checkbox, {
                                    slot: "end",
                                    modelValue: _ctx.sect1.renew,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.sect1.renew = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, { size: "6" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "check" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Öko")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_icon, {
                                    src: "/img/emoji/bulb_emoji_u1f4a1.svg",
                                    size: "normal"
                                  }),
                                  _createVNode(_component_ion_checkbox, {
                                    slot: "end",
                                    modelValue: _ctx.sect1.eco,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.sect1.eco = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_subtitle, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Mobilität "),
                      _createVNode(_component_ion_icon, {
                        src: "/img/emoji/board_emoji_u1f6f9.svg",
                        size: "large"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, { class: "sector" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_text, null, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_segment, {
                    onIonChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.segmentChanged($event,"s2"))),
                    value: "normal"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_segment_button, {
                        value: "besser",
                        layout: "icon-bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            src: "/img/emoji/bike_emoji_u1f6b2.svg",
                            size: "normal"
                          }),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Kein Auto")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_segment_button, {
                        value: "normal",
                        layout: "icon-bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            src: "/img/emoji/mobility.svg",
                            size: "normal"
                          }),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Normal")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_segment_button, {
                        value: "schlechter",
                        layout: "icon-bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            src: "/img/emoji/plane_emoji_u2708.svg",
                            size: "normal"
                          }),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Viele Flüge")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_subtitle, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Ernährung "),
                      _createVNode(_component_ion_icon, {
                        src: "/img/emoji/food_emoji_u1f355.svg",
                        size: "large"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, { class: "sector" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_text, null, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_segment, {
                    onIonChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.segmentChanged($event,"s3"))),
                    value: "normal"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_segment_button, {
                        value: "besser",
                        layout: "icon-bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            src: "/img/emoji/food_emoji_u1f955.svg",
                            size: "normal"
                          }),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Kein Fleisch")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_segment_button, {
                        value: "normal",
                        layout: "icon-bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            src: "/img/emoji/food_emoji_u1f35d.svg",
                            size: "normal"
                          }),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Normal")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_segment_button, {
                        value: "schlechter",
                        layout: "icon-bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            src: "/img/emoji/food_emoji_u1f357.svg",
                            size: "normal"
                          }),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Viel Fleisch")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_subtitle, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" Konsum "),
                      _createVNode(_component_ion_icon, {
                        src: "/img/emoji/shopping_emoji_u1f6cd.svg",
                        size: "large"
                      }),
                      _createTextVNode(" und Geld "),
                      _createVNode(_component_ion_icon, {
                        src: "/img/emoji/money_emoji_u1f4b0.svg",
                        size: "large"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, { class: "sector" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_text, null, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_segment, {
                    onIonChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.segmentChanged($event,"s4"))),
                    value: "normal"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_segment_button, {
                        value: "besser",
                        layout: "icon-bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            src: "/img/emoji/shopping_emoji_u1f6d2.svg",
                            size: "small"
                          }),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Wenig")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_segment_button, {
                        value: "normal",
                        layout: "icon-bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            src: "/img/emoji/shopping_emoji_u1f6d2.svg",
                            size: "normal"
                          }),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Normal")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_segment_button, {
                        value: "schlechter",
                        layout: "icon-bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            src: "/img/emoji/shopping_emoji_u1f6d2.svg",
                            size: "large"
                          }),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Viel")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_grid, { fixed: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { size: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "check" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Grünes Konto")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_icon, {
                                    src: "/img/emoji/stock_emoji_u1f4c8.svg",
                                    size: "normal"
                                  }),
                                  _createVNode(_component_ion_checkbox, {
                                    slot: "end",
                                    modelValue: _ctx.sect4.stock,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.sect4.stock = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, { class: "card-md" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Weitersagen")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_subtitle, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Können Sie in Ihrem Stadtteil Mitstreiter gewinnen?")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.districtsLoaded)
                ? (_openBlock(), _createBlock(_component_ion_card_content, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Stadtteil")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_select, {
                            "ok-text": "OK",
                            "cancel-text": "Abbrechen",
                            placeholder: "Bitte wählen",
                            onIonChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.districtChanged($event)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_select_option, { value: "0" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Bitte wählen")
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.districts, (item) => {
                                return (_openBlock(), _createBlock(_component_ion_select_option, {
                                  key: item.idx,
                                  value: item.idx,
                                  modelValue: _ctx.district,
                                  text: item.name
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "modelValue", "text"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_text, null, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_range, {
                        min: "0",
                        max: "50",
                        color: "secondary",
                        modelValue: _ctx.mult,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.mult = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.mult), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, { class: "card-md" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Auswerten")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_subtitle, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ihr Vergleich zum Durchschnitt: " + _toDisplayString(_ctx.performance), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Mitmachen")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" Senden Sie Ihre Angaben ab für "),
                  _hoisted_14
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_footer, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    expand: "block",
                    class: "submit",
                    onClick: _ctx.submit
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Abschicken")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_ion_button, {
                    expand: "block",
                    fill: "outline",
                    class: "routelink",
                    href: "https://www.karlsruhe.de/impressum"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Impressum")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, { size: "12" }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        size: "8",
                        offset: "2"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_ion_img, {
                              slot: "start",
                              src: "/img/logo.svg",
                              class: "appdesign",
                              alt: "OK Lab Karlsruhe"
                            }),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _hoisted_17
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, { class: "totalco2" }, {
                default: _withCtx(() => [
                  _createTextVNode("Aktuell: " + _toDisplayString(_ctx.co2total) + " t CO", 1),
                  _hoisted_18
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}